// extracted by mini-css-extract-plugin
export default {"form":"CryptoItemForm_form__amQ6U"};